import axios from "axios";
import { axiosInstance } from "../../auth/Auth";
import { toast } from "react-toastify";
import moment from "moment";

export function setCurrentTime(audioElement, seconds) {
    audioElement.currentTime = seconds;
}
export function startAudioPlay(audioElement, setIsPlaying) {
    if (audioElement) {
        audioElement.play();
        setIsPlaying(true);
    }
}
export function toggleAudioPlay(audioElement, setIsPlaying, isAudioAvailable) {
    if (!isAudioAvailable) return;
    if (audioElement) {
        if (audioElement.paused) {
            audioElement.play();
            setIsPlaying(true);
        } else {
            audioElement.pause();
            setIsPlaying(false);
        }
    }
}
export function increasePlaybackSpeed(audioElement, setPlaybackRate, isAudioAvailable) {
    if (!isAudioAvailable) return;
    const newRate = Math.min(2.5, audioElement.playbackRate + 0.25);
    audioElement.playbackRate = newRate;
    setPlaybackRate(newRate);
}
export function decreasePlaybackSpeed(audioElement, setPlaybackRate, isAudioAvailable) {
    if (!isAudioAvailable) return;
    const newRate = Math.max(0.5, audioElement.playbackRate - 0.25);
    audioElement.playbackRate = newRate;
    setPlaybackRate(newRate);
}
export function setMark(setMarkSeconds, seconds) {
    setMarkSeconds(seconds);
}
export function clearMarks(setMarkInSeconds, setMarkOutSeconds) {
    setMarkInSeconds(0);
    setMarkOutSeconds(0);
}

export async function downloadMp3(radioId, startTime, endTime, duration, jobType) {
    // Build url
    let url = `mp3service/?radio_id=${radioId}&start_time=${startTime}`;
    if (endTime) url += `&end_time=${endTime}`;
    if (duration) url += `&duration=${duration}`;
    if (jobType) url += `&job_type=${jobType}`;
    // Get audio url
    const response = await axiosInstance.get(encodeURI(url));
    // Get audio file with retry logic for 30 seconds
    const maxRetries = 30;
    let retries = 0;
    let fileResponse;
    while (!fileResponse && retries < maxRetries) {
        try {
            // Get audio file
            fileResponse = await axios.get(response.data, { responseType: "blob" });
        } catch (error) {
            retries++;
            await new Promise(resolve => setTimeout(resolve, 1000)); // Retry after 1 second
        }
    }
    if (!fileResponse) return;
    // Create blob link
    const blobUrl = window.URL.createObjectURL(new Blob([fileResponse.data]));
    // Simulate clicking on download link
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = response.data.substring(response.data.lastIndexOf("/") + 1);
    link.click();
}

export async function createBitInNewCollection(radioId, collectionName, bitName, bitStart, bitEnd) {
    const newCollection = await createCollection(radioId, collectionName);
    const newBit = await createBit(newCollection.collection_id, bitName, bitStart, bitEnd);
    return newBit;
}

export async function createCollection(radioId, name) {
    try {
        const input = { radio_id: radioId, collection_name: name };
        const response = await axiosInstance.post("freestyle_deltas/current_user/", input);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export async function createBit(collectionId, name, bitStart, bitEnd) {
    try {
        const input = {
            start_datetime: bitStart,
            end_datetime: bitEnd,
            bit_name: name ?? `${moment(bitStart).format("L LTS")} - ${moment(bitEnd).format("L LTS")}`,
        };
        const response = await axiosInstance.post(`freestyle_deltas/${collectionId}/bits/`, input);
        toast.success(`Bit successfully added to collection.`, { autoClose: 5000 });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.detail ?? "An unexpected error occurred");
        console.error(error);
    }
}
